import {
  Component, AfterViewInit, Input,
  Inject, ViewChild, Output, EventEmitter,
} from '@angular/core';

import * as angular from 'angular';
import * as _ from 'lodash';
import 'fullcalendar';
import moment = require('moment');

declare var jQuery;

@Component({
  selector: 'datepicker',
  host: {
    '(document:click)': 'onWindowClick($event)',
  },
  template: `
    <div class="date-picker" [class.-has-icon]="showIcon" [class.-clearable]="clearable" [class.-is-input]="actAsInput">
      <div #calendarBtn class="date" (click)="disabled || toggleDatePicker($event)" [class.-disabled]="disabled">
        <span class="-calendar" *ngIf="showIcon"></span>
        <input [class.-has-value]="date !== null" [name]="inputName" [id]="inputName" readonly="readonly" type="text" [value]="date | dateTimeFormat: dateFormat" [placeholder]="placeholder" [class.-disabled]="disabled" [disabled]="disabled" />
        <span (click)="setDate(null)" class="-close" [class.-disabled]="disabled" [class.-no-visible]="!date || !clearable"></span>
      </div>
      <div [hidden]="!visibleDatePicker">
        <div #calendar class="calendar" [class.-top]="calendarPlacement === 'top'"></div>
      </div>
    </div>
  `,
})

export class DatePickerComponent implements AfterViewInit {
  @Input() calendarOptions: Object;
  @Input() date: string;
  @Input() futureDate: boolean = false;
  @Input() min: moment.Moment;
  @Input() max: moment.Moment;
  @Input() placeholder: string = '---';
  @Input() showIcon: boolean = true;
  @Input() inputName: string = 'date';
  @Input() disabled: boolean = false;
  @Input() clearable: boolean = false;
  @Input() actAsInput: boolean = false;
  @Input() dateFormat: string = 'day_month_and_year';
  @Input() calendarPlacement: string = 'bottom'; // Can either be 'top' or 'bottom'
  @Output() dateChange: EventEmitter<string> = new EventEmitter<string>();

  calendarElement: any;

  private visibleDatePicker: boolean = true;

  defaultOption: Object = {
    contentHeight: 235,
    timeFormat: 'h:mm',
    firstDay: 0,
    dayClick: (date, jsEvent, view) => {
      if (date.month() ===  view.intervalStart.month() && this.isValidDate(date)) {
        this.setDate(date);
        this.visibleDatePicker = false;
      }
    },
    lang: this.$translate.use(),
    eventLimit: 0,
    monthNames: moment.months('MMM'),
    dayNames: moment.weekdays(),
    timezone: 'local',
    dayNamesShort: moment.weekdaysMin().map(day => (day.substr(0, 1))),
    header: {
      center: 'title',
      left: 'prev',
      right: 'next'
    },
    dayRender: (date, cell) => {
      if (!this.isValidDate(date)) {
        jQuery(`td.fc-day-top[data-date='${date.format('YYYY-MM-DD')}']`).addClass('fc-invalid-day');
      }
    }
  };

  @ViewChild('calendar') calendar;
  @ViewChild('calendarBtn') calendarBtn;

  constructor(@Inject('$translate') private $translate) {
  }

  ngAfterViewInit() {
    this.calendarOptions = _.extend({}, this.defaultOption, this.calendarOptions);

    this.calendarElement = angular.element(this.calendar.nativeElement);
    this.calendarElement.fullCalendar(this.calendarOptions);
    this.visibleDatePicker = false;

    if (this.date && this.date.length) {
      this.setDate(moment(this.date, 'YYYY-MM-DD'));
    } else {
      this.setDate(null);
    }

    this.gotoValidDate();
  }

  setDate(date) {
    this.date = (date) ? date.format('YYYY-MM-DD') : null;

    this.dateChange.emit(this.date);
    this.getCalendar().find('.selected-date').removeClass('selected-date');
    this.getCalendar().find(`[data-date=${this.date}]`).addClass('selected-date');
  }

  getCalendar() {
    return angular.element(this.calendar.nativeElement);
  }

  toggleDatePicker(event) {
    this.visibleDatePicker = !this.visibleDatePicker;
    event.stopPropagation();
  }

  onWindowClick(event) {
    if (!this.calendar.nativeElement.contains(event.target)) {
      this.visibleDatePicker = false;
    }
  }

  isValidDate(date: moment.Moment): boolean {
    if (this.futureDate && date.isBefore(moment(), 'day')) {
      return false;
    }
    return (!this.min || !date.isBefore(this.min, 'day')) && (!this.max || !date.isAfter(this.max, 'day'));
  }

  gotoValidDate () {
    const date = moment(this.date ? this.date : {}).startOf('day');
    if (!this.isValidDate(date)) {
      this.calendarElement.fullCalendar('gotoDate', this.min ? this.min : this.max );
    }
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/datepicker/datepicker.component.ts